import { connect } from "react-redux";

import {
	submitBinaryQuestion,
	skipQuestion,
} from "ducks/questions";

import BinaryQuestion from "apps/questions/components/BinaryQuestion";

function mapStateToProps(state) {
	return {
		isProcessing: state.questions.isProcessing,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		onSubmit(params) {
			dispatch(submitBinaryQuestion(params));
		},

		onSkip() {
			dispatch(skipQuestion());
		},
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(BinaryQuestion);



// WEBPACK FOOTER //
// ./src/apps/questions/containers/BinaryQuestion.js